// ボス近接判定の空間形状: 実判定とdev H表示が使う唯一の置き場。
// 攻撃段ごとに作者が指定したfacing-local区間をworldへ変換する。
import type { Facing, StrikeProfile } from './types'

export type StrikeWorldInterval = {
  xStart: number
  xEnd: number
}

// authoredなfacing-local区間をworld座標へ変換する唯一の純関数。
// 物理判定とHデバッグ表示が必ず同じ結果を使う。
export function strikeWorldInterval(
  bossX: number, facing: Facing, strike: StrikeProfile,
): StrikeWorldInterval {
  if (!Number.isFinite(strike.localFromPx) || !Number.isFinite(strike.localToPx)
      || strike.localFromPx > strike.localToPx) {
    throw new Error(`[strike] invalid local interval: ${strike.localFromPx}..${strike.localToPx}`)
  }
  const dir = facing === 'right' ? 1 : -1
  const a = bossX + dir * strike.localFromPx
  const b = bossX + dir * strike.localToPx
  return { xStart: Math.min(a, b), xEnd: Math.max(a, b) }
}

export function intervalsOverlap(
  aStart: number, aEnd: number, bStart: number, bEnd: number,
): boolean {
  return aEnd >= bStart && aStart <= bEnd
}

export function playerHurtboxOverlapsStrike(
  playerX: number, playerWidth: number, strikeInterval: StrikeWorldInterval,
): boolean {
  const half = playerWidth / 2
  return intervalsOverlap(
    playerX - half, playerX + half,
    strikeInterval.xStart, strikeInterval.xEnd,
  )
}
